/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1CouponId202,
  DeleteApiV1CouponId401,
  DeleteApiV1CouponId404,
  DeleteApiV1CouponId500,
  DeleteApiV1CouponIdMutationResponse,
  DeleteApiV1CouponIdPathParams,
} from "../../types/couponRegistroController/DeleteApiV1CouponId.ts";

export const deleteApiV1CouponIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1CouponIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1CouponId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1CouponId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1CouponId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1CouponId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1CouponId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1CouponId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1CouponId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1CouponId500>;

export const deleteApiV1CouponIdMutationResponseSchema = z.lazy(
  () => deleteApiV1CouponId202Schema,
) as unknown as ToZod<DeleteApiV1CouponIdMutationResponse>;
